import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";

/**
 * Wraps public auth pages (login / register / welcome). If the user is
 * already authenticated, redirect them to the app instead of letting them
 * sit on these pages.
 */
export const RedirectIfAuth = ({
  children,
  redirectPath = "/",
}: {
  children: JSX.Element;
  redirectPath?: string;
}) => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    setAuthed(isAuthenticated());
    setChecked(true);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!checked) {
    return null;
  }

  if (authed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
